<div class="text-center">
  <img src="./assets/Images/Logo2.svg" alt="Logo">
</div>
@if (!isTwoFactorLogin) {
  <div>
    <div class="mobile-response">
      <div class="card col-lg-3 col-md-11 col-11 mx-auto" style="max-width: 440px !important;" [ngClass]="{'big-margin': !isEmailPending}">
        <div class="card-body">
          <h4>Anmeldung</h4>
          <!-- Error Messages -->
          @if (isError && loginStep === 'password') {
            <div style="margin-top: 1.75rem" class="validation-card">
              <i style="margin-left: 0.5rem;" class="icon-exclamation-circle position-absolute"></i>
              <span class="validation-error-card" style="margin-left:2.5rem; color:var(--main-black);">Falsche Email oder falsches Passwort</span>
            </div>
          }
          @if (isEmailPending) {
            <div class="card-info p-0 pending">
              <div class="card-body" style="padding-bottom: 0px;">
                <div class="grid">
                  <span class="icon-info mt-1" style="font-size: 20px"></span>
                  <span style="font-size: 14px; color: white" class="mb-0">Dieses Konto hat einen ausstehenden Bestätigungsstatus. Bitte bestätigen Sie Ihr Konto, um sich anzumelden.</span>
                  <span></span>
                  <p (click)="resendEmail()" class="m-0 mb-1">Bestätigungs-E-Mail erneut senden</p>
                </div>
              </div>
            </div>
          }
          <form [formGroup]="loginForm" style="margin-top: 0.75rem" (ngSubmit)="onSubmit()">
            <!-- Step 1: Email Input (Always Visible) -->
            <label class="form-label w-100">
              Email<span class="required">*</span>
              <input type="email"
                formControlName="email"
                class="form-control"
                placeholder="Ihre Email"
                [readonly]="loginStep !== 'email'"
                [ngClass]="loginForm.get('email')!.hasError('required') && loginForm.get('email')!.touched || loginForm.get('email')!.hasError('email') && loginForm.get('email')!.touched ? 'invalid' : ''"
                [style]="loginForm.get('email')!.hasError('required') && loginForm.get('email')!.touched || loginForm.get('email')!.hasError('email') && loginForm.get('email')!.touched ? 'padding-left: 2.25rem !important' : ''">
              @if ((loginForm.get('email')!.hasError('required') || loginForm.get('email')!.hasError('email')) && loginForm.get('email')!.touched) {
                <i class="icon-cancel"></i>
              }
              @if (loginForm.get('email')!.hasError('required') && loginForm.get('email')!.touched) {
                <span style="color: var(--main-error-color); font-size: 12px;" class="mb-3">Dieses Feld ist erforderlich.</span>
              }
              @if (loginForm.get('email')!.hasError('email') && loginForm.get('email')!.touched) {
                <span style="color: var(--main-error-color); font-size: 12px;" class="mb-3">Bitte geben Sie eine gültige E-Mail-Adresse ein.</span>
              }
            </label>
            <!-- Step 2: Password Input (Only shown for local login) -->
            @if (loginStep === 'password') {
              <div class="login-step-fade-in">
                <label class="form-label w-100 mt-3">
                  Passwort<span class="required">*</span>
                  <div class="position-relative">
                    <input noTrim [type]="isPasswordVisible ? 'text' : 'password'"
                      formControlName="password"
                      class="form-control"
                      placeholder="•••••••••••••"
                      [ngClass]="isError || loginForm.get('password')!.hasError('required') && loginForm.get('password')!.touched ? 'invalid' : ''"
                      [style]="isError || loginForm.get('password')!.hasError('required') && loginForm.get('password')!.touched ? 'padding-left: 2.25rem !important;' : ''">
                    <i class="visibility-icon"
                      [class.icon-visibility-on]="!isPasswordVisible"
                      [class.icon-visibility-off]="isPasswordVisible"
                    (click)="isPasswordVisible = !isPasswordVisible"></i>
                    @if (isError || loginForm.get('password')!.hasError('required') && loginForm.get('password')!.touched) {
                      <i class="icon-cancel"></i>
                    }
                  </div>
                  @if (loginForm.get('password')!.hasError('required') && loginForm.get('password')!.touched) {
                    <span style="color: var(--main-error-color); font-size: 12px;" class="mb-3">Dieses Feld ist erforderlich.</span>
                  }
                </label>
              </div>
            }
            <!-- Microsoft Login Progress Message -->
            @if (loginStep === 'microsoft') {
              <div class="login-step-fade-in text-center mt-3 mb-3">
                <div class="d-flex align-items-center justify-content-center">
                  <svg width="21" height="21" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" class="me-2">
                    <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
                    <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
                    <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
                    <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
                  </svg>
                  <span style="color: #5E5E5E; font-size: 14px;">Weiter mit Microsoft...</span>
                </div>
              </div>
            }
            <!-- Merck SSO Login Progress Message -->
            @if (loginStep === 'merck') {
              <div class="login-step-fade-in text-center mt-3 mb-3">
                <div class="d-flex align-items-center justify-content-center">
                  @if (isMerckLoginInProgress) {
                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  }
                  <span class="merk-loading-login">Weiter mit Merck SSO...</span>
                </div>
              </div>
            }
            <!-- Submit Button -->
            <button type="submit"
              class="btn btn-primary login-btn d-block mx-auto"
                  [disabled]="(loginStep === 'email' && loginForm.get('email')!.invalid) ||
                              (loginStep === 'password' && loginForm.invalid) ||
                              isEmailPending ||
                              isCheckingEmail ||
                              isMicrosoftLoginInProgress ||
                              isMerckLoginInProgress">
              @if (isCheckingEmail) {
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              }
              <span>{{ loginStep === 'email' ? (isCheckingEmail ? 'Überprüfung...' : 'Weiter') : 'Anmeldung' }}</span>
            </button>
            <!-- Back Button (shown when not on email step) -->
            @if (loginStep !== 'email' && loginStep !== 'merck') {
              <button
                type="button"
                class="btn btn-link d-block mx-auto mt-2"
                (click)="goBackToEmail()"
                style="color: #6c757d; font-size: 14px; text-decoration: none;">
                Nicht Sie?
              </button>
            }
          </form>
        </div>
      </div>
      <div class="text-center mt-md-4 link">
        <span class="link-btn" (click)="GoToForgotPassword()">Passwort vergessen </span> |
        <!-- <span class="link-btn" (click)="GoToRegister()"> Registrieren</span> -->
      </div>
      <div class="text-center link">
        <a [href]="'https://www.ing-plus.de/datenschutz'" target="_blank" class="link-btn no-decoration">Datenschutzerklärung</a> <span class="link-btn"> |</span>
        <a [href]="'https://www.ing-plus.de/impressum'" target="_blank" class="link-btn no-decoration ml-1">Impressum </a>
      </div>
    </div>
  </div>
}
@if (isTwoFactorLogin) {
  <div class="mobile-response" style="background-color: var(--main-black) !important;">
    <div class="card col-lg-3 col-md-11 col-11 mx-auto big-margin" style="max-width: 440px !important;">
      <div class="card-body">
        <h4 class="mb-0">Code eingeben</h4>
        <div class="my-4 fs-14">Ein einmaliges Passwort wurde an Ihre E-Mail-Adresse gesendet</div>
        @if (isWrongCode) {
          <div class="validation-card mt-2">
            <i class="icon-exclamation-circle position-absolute ml-2"></i>
            <span style="margin-left:2.5rem;">Ungültiger Code, versuchen Sie es erneut.</span>
          </div>
        }
        <ng-otp-input class="otp-code text-center" [class.invalid]="isWrongCode" (onInputChange)="onOtpChange($event)" [config]="{length:6, allowNumbersOnly:true}"></ng-otp-input>
        <div class="mt-2 d-flex flex-column">
          @if (isRunning) {
            <span class="time-reset-code">Neuen Code anfordern in {{ minutes }}:{{ seconds | number: '2.0' }} ab</span>
          }
          <button class="send-code-button link-btn d-flex" [style.color]="isRunning ? '#AFAFB2' : 'var(--main-black)'" (click)="resetTimer(); onSubmit();" [disabled]="isRunning">Code erneut senden</button>
        </div>
        <div class="text-center">
          <button type="button" class="btn btn-primary login-btn submit-button" (click)="loginTwoFactor()">Authentifizieren</button>
        </div>
      </div>
    </div>
    <div class="text-center mt-md-4 link">
      <span class="link-btn" (click)="isTwoFactorLogin = false;">Zurück zu Login</span>
    </div>
  </div>
}
